export function validatePassword(password) {
    const regex = /^(?=.*\d)(?=.*[a-z]).{4,}$/;
    return regex.test(password);
  }

  export function validateEmail(email) {
    const re =/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return re.test(email);
  }